import { AgmCoreModule } from '@agm/core';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule } from '@angular/forms';
import { MatButtonModule } from '@angular/material/button';
import { MatCheckboxModule } from '@angular/material/checkbox';
import { MatChipsModule } from '@angular/material/chips';
import { MatRippleModule } from '@angular/material/core';
import { MatDividerModule } from '@angular/material/divider';
import { MatExpansionModule } from '@angular/material/expansion';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatIconModule } from '@angular/material/icon';
import { MatInputModule } from '@angular/material/input';
import { MatMenuModule } from '@angular/material/menu';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSelectModule } from '@angular/material/select';
import { MatSnackBarModule } from '@angular/material/snack-bar';
import { MatSortModule } from '@angular/material/sort';
import { MatTableModule } from '@angular/material/table';
import { MatTabsModule } from '@angular/material/tabs';
import { MatTooltipModule } from '@angular/material/tooltip';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { FuseSidebarModule, FuseWidgetModule } from '@fuse/components';
import { FuseSharedModule } from '@fuse/shared.module';
import { TranslateModule } from '@ngx-translate/core';
import { PipesModule } from 'app/pipes/pipes.module';
import { OwlDateTimeModule, OwlNativeDateTimeModule } from 'ng-pick-datetime';
import { SimulationCarFormComponent } from './car/car-form/car-form.component';
import { SimulationContainerFormComponent } from './container/container-form/container-form.component';
import { SimulationContainerLocationFormComponent } from './container/container-location-form/container-location-form.component';
import { SimulationZoneFormComponent } from './zone/zone-form/zone-form.component';
import { SimulationZoneUpdateComponent } from './zone/zone-update/zone-update.component';
import { SimulationCarListComponent } from './car/car-list/car-list.component';
import { SimulationContainerListComponent } from './container/container-list/container-list.component';
import { GarbageCenterFormComponent } from './garbage-center-form/garbage-center.component';
import { MapContainerFormComponent } from './map-container-form/map-container-form.component';
import { MarkerFormComponent } from './marker-form/marker-form.component';
import { PoligonFormComponent } from './poligon-form/poligon-form.component';
import { SimulationZoneListComponent } from './zone/zone-list/zone-list.component';
import { SimulationReportingComponent } from './simulation-reporting/simulation-reporting.component';
import { MatCardModule } from '@angular/material/card';
import { MatProgressBarModule } from '@angular/material/progress-bar';
import { SimulationMapComponent } from './maps/map.component';
import { SetStartLocationComponent } from './simulation-reporting/set-start-location/set-start-location-form.component';
import { MatDatepicker, MatDatepickerModule } from '@angular/material/datepicker';
import { SimulationTestComponent } from './simulation-test/simulation-test.component';



@NgModule({
    declarations: [
        SimulationMapComponent,
        PoligonFormComponent,
        GarbageCenterFormComponent, 
        MarkerFormComponent, 
        MapContainerFormComponent,
        SimulationCarListComponent,
        SimulationContainerListComponent,
        SimulationZoneListComponent,
        SimulationCarFormComponent,
        SimulationContainerFormComponent,
        SimulationContainerLocationFormComponent,
        SimulationZoneFormComponent,
        SimulationZoneUpdateComponent,
        SimulationReportingComponent,
        SetStartLocationComponent,
        SimulationTestComponent
    ],
    imports: [
        CommonModule,
        MatButtonModule,
        MatDividerModule,
        MatFormFieldModule,
        MatIconModule,
        MatMenuModule,
        TranslateModule,
        MatSelectModule,
        MatTableModule,
        BrowserAnimationsModule,
        MatCheckboxModule,
        FuseSharedModule,
        MatTooltipModule,
        FuseSidebarModule,
        FuseWidgetModule,
        MatChipsModule,
        MatDatepickerModule,
        MatExpansionModule,
        MatCardModule,
        MatInputModule,
        MatPaginatorModule,
        MatRippleModule,
        MatSortModule,
        MatTabsModule,
        MatProgressBarModule,
        MatSnackBarModule,
        MatIconModule,
        PipesModule,
        OwlDateTimeModule,
        OwlNativeDateTimeModule,
        FormsModule,
        AgmCoreModule.forRoot({
            apiKey: 'AIzaSyD81ecsCj4yYpcXSLFcYU97PvRsE_X8Bx8'
        })
    ],
    providers: []
})
export class SimulationMapModule { }
